import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomActionButton, {atomActionButtonStyles} from '@s-ui/react-atom-action-button'
import AtomButton, {atomButtonDesigns, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import IconAlert from '@adv-mt/mt-svg-icons/lib/AlertOutline'

const TYPES = {
  ACTION_BUTTON: 'actionButton',
  INLINE_BUTTON: 'inlineButton',
  ICON_BUTTON: 'iconButton'
}

const ActionsAdReportButton = ({type, onClick}) => {
  const {i18n} = useContext(Context)

  if (type === TYPES.ICON_BUTTON) {
    return (
      <AtomButton
        design={atomButtonDesigns.FLAT}
        leftIcon={<IconAlert />}
        size={atomButtonSizes.LARGE}
        onClick={onClick}
      />
    )
  }

  if (type === TYPES.INLINE_BUTTON) {
    return (
      <AtomButton design={atomButtonDesigns.FLAT} leftIcon={<IconAlert />} onClick={onClick}>
        {i18n.t('COMMON.REPORT')}
      </AtomButton>
    )
  }

  return (
    <AtomActionButton icon={<IconAlert />} style={atomActionButtonStyles.FLAT} onClick={onClick}>
      {i18n.t('COMMON.REPORT')}
    </AtomActionButton>
  )
}

ActionsAdReportButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf(TYPES)
}

export default ActionsAdReportButton
